import { CountResponse } from '@interfaces/common.interface';
import {
  CountPathologiesRequestParams,
  CreatePathologyRequest,
  GetPathologiesRequestParams,
  Pathology,
  UpdatePathologyRequest,
} from '@interfaces/pathologies.interface';

import api from './';

export const {
  useCountPathologiesQuery,
  useGetManyPathologiesQuery,
  useCreatePathologyMutation,
  useUpdatePathologyMutation,
  useDeletePathologyMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    countPathologies: build.query<CountResponse, CountPathologiesRequestParams>(
      {
        query: (params) => ({ url: 'pathologies/count', params }),
        providesTags: ['pathologies'],
      },
    ),
    getManyPathologies: build.query<Pathology[], GetPathologiesRequestParams>({
      query: (params) => ({ url: 'pathologies', params }),
      providesTags: ['pathologies'],
    }),
    createPathology: build.mutation<Pathology, CreatePathologyRequest>({
      query: (body) => ({
        url: 'pathologies',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['pathologies'],
    }),
    updatePathology: build.mutation<Pathology, UpdatePathologyRequest>({
      query: ({ id, body }) => ({
        url: `genders/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['pathologies'],
    }),
    deletePathology: build.mutation<Pathology, string>({
      query: (id) => ({
        url: `pathologies/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['pathologies'],
    }),
  }),
});
